module["exports"] = [
  "co.za",
  "com",
  "org.za",
  "info",
  "net.za"
];